import { render, staticRenderFns } from "./BidLocationDisplay.vue?vue&type=template&id=37791e0f&"
import script from "./BidLocationDisplay.vue?vue&type=script&lang=js&"
export * from "./BidLocationDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports